// src/shared/hooks/useAppRoutes.ts
import { useMemo } from "react";
import { AUTH_ROUTES } from "@/auth/routes.ts";
import { DASHBOARD_ROUTE } from "@/dashboard/routes.ts";
import AuthLayout from "@/shared/components/layout/auth-layout.tsx";
import { TLayoutRoute, TRoute } from "@/shared/types/route.ts";
import { MACHINE_ROUTES, MACHINES_URL } from "@/machines/routes.ts";
import { SETTINGS_ROUTES } from "@/settings/routes.ts";
import { ML_EXPORTS_ROUTES } from "@/ml-exports/routes.ts";
import { MAP_ROUTES } from "@/map/routes.ts";
import { ALERTS_ROUTES } from "@/alerts/routes.ts";
import DashboardLayout from "@/shared/components/layout/dashboard-layout/dashboard-layout.tsx";
import Locations from "@/machines/pages/location/locations.tsx";
import SkeletonPage from "@/shared/components/skeleton/page/skeleton-page.tsx";
import NotFound from "@/shared/components/common/not-found/not-found.tsx";

export const useAppRoutes = () => {
  const routes: TLayoutRoute[] = useMemo(() => {
    const authRoutes = Object.values(AUTH_ROUTES);
    const dashboardRoutes = [
      ...Object.values(DASHBOARD_ROUTE),
      ...Object.values(MACHINE_ROUTES),
      ...Object.values(SETTINGS_ROUTES),
      ...Object.values(ML_EXPORTS_ROUTES),
      ...Object.values(MAP_ROUTES),
      ...Object.values(ALERTS_ROUTES),
      {
        name: "not-found",
        path: `*`,
        component: NotFound,
        roles: [],
      }
    ];
    return [
      {
        layout: DashboardLayout,
        routes: dashboardRoutes,
      },
      {
        layout: AuthLayout,
        routes: authRoutes,
      },
    ];
  }, []);

  return routes;
};
